import { HermesClient, deriveDefaultHermesUrl } from "./hermes-client.js";

const token = new URLSearchParams(location.search).get("token") || "";

/**
 * Hermes gateway base URL with no trailing slash. Paths like `/v1/...` are appended by HermesClient.
 * - When unset (`dev` and production): defaults to `""` (same origin). With `vite dev`, `/v1` and `/health`
 *   go through the dev proxy like `fetch("/health")` in the shell, avoiding CORS when the gateway does not
 *   allow the browser dev origin. Direct gateway: `VITE_HERMES_BASE_URL=http://127.0.0.1:8642 npm run dev`
 * - Production: same-origin requests require a reverse proxy that forwards `/v1` and `/health`.
 * - Override at build time: `VITE_HERMES_BASE_URL=https://host:8642 pnpm build`
 */
function resolveHermesBaseUrl(): string {
  const raw = import.meta.env.VITE_HERMES_BASE_URL;
  if (typeof raw === "string" && raw.trim()) {
    return raw.trim().replace(/\/+$/, "");
  }
  return "";
}

const hermesBaseUrl = resolveHermesBaseUrl();

// Singleton instance of HermesClient
export const hermesClient = new HermesClient({ baseUrl: hermesBaseUrl, token });

/** Resolved gateway base (no trailing slash). Empty in production = same origin. */
export const HERMES_BASE_URL = hermesBaseUrl;

// Re-export for convenience
export { HermesClient, deriveDefaultHermesUrl } from "./hermes-client.js";